import _defineProperty from '@babel/runtime/helpers/defineProperty';
import borders from './borders.js';
import breakpoints from './breakpoints.js';
import colors from './colors.js';
import radii from './radius.js';
import shadows from './shadows.js';
import sizes from './sizes.js';
import space from './space.js';
import transition from './transition.js';
import typography from './typography.js';
import zIndices from './z-index.js';
import blur from './blur.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var foundations = _objectSpread(_objectSpread({
  breakpoints: breakpoints,
  zIndices: zIndices,
  radii: radii,
  blur: blur,
  colors: colors
}, typography), {}, {
  sizes: sizes,
  shadows: shadows,
  space: space,
  borders: borders,
  transition: transition
});
var foundations$1 = foundations;
export { foundations$1 as default };